import { useQuery } from '@tanstack/react-query'
import { fetchSearchCoins } from '@api/search/api.js'
import { useCallback } from 'react'

export const useSearchQuery = (body = {}) => {
  return useQuery({
    queryKey: ['search-data', body],
    queryFn: () => fetchSearchCoins(body),
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    select: useCallback(({ coins }) => coins, []),
    throwOnError: true
  })
}
